import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AiKnowledgeService } from '../../ai-knowledge.service';
import { AiKnowledgeI18nModule } from '../../assets/i18n/ai-knowledge-i18n.module';
import { MatCardModule } from '@angular/material/card';
import { CustomDataComponent } from '../custom-data/custom-data.component';
import { WebsiteScrapeComponent } from '../website-scrape/website-scrape.component';
import { CommonKnowledgeSourceEditorComponent } from '../common/common-knowledge-source-editor.component';

interface Choice {
  title: string;
  description: string;
  component: any;
}

@Component({
  selector: 'ai-knowledge-add-knowledge',
  standalone: true,
  imports: [CommonModule, TranslateModule, AiKnowledgeI18nModule, MatCardModule],
  providers: [AiKnowledgeService],
  templateUrl: './add-knowledge.component.html',
  styleUrls: ['./add-knowledge.component.scss'],
})
export class AddKnowledgeComponent extends CommonKnowledgeSourceEditorComponent {
  @Output() componentSelected = new EventEmitter<any>();

  choices: Choice[] = [
    {
      title: 'EDIT_KNOWLEDGE.CUSTOM_DATA_CONFIG.TITLE',
      description: 'EDIT_KNOWLEDGE.CUSTOM_DATA_CONFIG.DESCRIPTION',
      component: CustomDataComponent,
    },
    {
      title: 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.TITLE',
      description: 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.DESCRIPTION',
      component: WebsiteScrapeComponent,
    },
  ];

  selectComponent(choice: Choice): void {
    this.componentSelected.emit(choice.component);
  }
}
